(function () {
  'use strict';

  /**
   * APO Image Swap (Bont) — vanilla rewrite.
   * Modes (via product tags):
   *   mybont-swap-order  → overlays only (base hidden)
   *   quad-swap-order    → base visible under overlays
   *   inline-swap-order  → base visible; reversed overlay order
   * Corrected vs the old jQuery engine: official mwApoInit readiness with a
   * bounded poll fallback; targeted listeners (no body-wide observer); no
   * speculative-global nudging; graceful degradation if APO never loads.
   */

  var OVERLAY_BASE_Z = 20;
  var POLL_INTERVAL = 500;
  var MAX_ATTEMPTS = 20; // ~10s readiness fallback

  // ---- Pure utilities (unit-tested) --------------------------------------

  function normalizeName(name) {
    if (!name) return '';
    return String(name)
      .toLowerCase()
      .trim()
      .replace(/&/g, 'and')
      .replace(/( |\/|\\|_)+/g, '-')
      .replace(/[^\w-]/g, '')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function stripShopifyParams(url) {
    if (!url) return '';
    var clean = url.split('?')[0];
    return clean.replace(/_(\d+x\d*|\d*x\d+|\d+x)\.(jpg|jpeg|png|webp|gif|avif)$/i, '.$2');
  }

  function firstFromSrcset(srcset) {
    if (!srcset) return '';
    var first = srcset.split(',')[0].trim();
    return first.split(' ')[0] || '';
  }

  function getOverlayZIndex(mode, index) {
    if (mode === 'quad') return 10 + index;
    if (mode === 'inline') return OVERLAY_BASE_Z - index;
    return OVERLAY_BASE_Z + index;
  }

  function injectOnceStyles() {
    if (document.getElementById('apo-image-swap-styles')) return;
    var style = document.createElement('style');
    style.id = 'apo-image-swap-styles';
    style.textContent =
      '.overlay-image{transition:opacity 150ms ease-out;}' +
      '.bont-multi-product-img-container{transition:opacity 120ms ease-out;}';
    document.head.appendChild(style);
  }

  function ensureRelative(el) {
    if (!el) return;
    var pos = window.getComputedStyle(el).position;
    if (!pos || pos === 'static') el.style.position = 'relative';
  }

  var COLOUR_WORDS = /(red|blue|green|black|white|purple|lavender|pink|yellow|orange|brown|gray|grey|silver|gold|navy|teal|cyan|magenta|lime|olive|maroon|aqua|violet|indigo|turquoise|coral|salmon|khaki|tan|beige|ivory|cream|mint|sage|rose|wine|burgundy|crimson|azure|emerald|amber|bronze|copper|platinum|pearl)/i;

  function isColourOptionName(name) {
    var n = String(name || '').toLowerCase();
    return n.indexOf('color') !== -1 || n.indexOf('colour') !== -1;
  }

  /**
   * Resolve a normalised colour from ordered candidate inputs (DOM-agnostic so it
   * can be unit-tested). Candidates are gathered by resolveColour() in priority
   * order; the first one that reads as a colour wins. Each candidate:
   *   { kind: 'named-colour', value }                      // native Color radio (name already identifies it)
   *   { kind: 'select', value, text }                      // native colour <select> (prefer option text)
   *   { kind: 'shim', optionName, value }                  // APO variant shim wrap (colour iff optionName is a colour)
   *   { kind: 'generic-option', name, value }              // native options[...] radio (colour iff name/value looks like one)
   */
  function resolveColourFromCandidates(candidates) {
    if (!candidates) return '';
    for (var i = 0; i < candidates.length; i++) {
      var c = candidates[i];
      if (!c) continue;
      if (c.kind === 'named-colour') return normalizeName(c.value);
      if (c.kind === 'select') return normalizeName(c.text || c.value);
      if (c.kind === 'shim') {
        if (isColourOptionName(c.optionName)) return normalizeName(c.value);
        continue;
      }
      if (c.kind === 'generic-option') {
        if (isColourOptionName(c.name) || COLOUR_WORDS.test(c.value || '')) {
          return normalizeName(c.value);
        }
      }
    }
    return '';
  }

  // ---- Engine ------------------------------------------------------------
  // Guard the DOM engine so the file can also be required under Node (for the
  // pure-utility unit tests) where `window`/`document` do not exist.
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {

  window.apoImageSwap = {
    mode: null,        // 'mybonts' | 'quad' | 'inline' | null
    baseLayers: [],    // NodeList → array of .bont-multi-product-img-container
    host: null,        // .bont-product-media-container
    ready: false,
    renderQueued: false,

    init: function () {
      this.host = document.querySelector('.bont-product-media-container');
      if (!this.host) return; // not an image-swap product page
      this.baseLayers = Array.prototype.slice.call(
        document.querySelectorAll('.bont-multi-product-img-container')
      );

      // Mode is resolved once in Liquid (snippets/apo-product-mode.liquid) and
      // emitted as window.apoSwapMode by the image-swap gallery snippet.
      this.mode = window.apoSwapMode || null;

      injectOnceStyles();
      this.whenApoReady(this.onReady.bind(this));
    },

    /** Resolve readiness via the official bus AND a bounded poll; fire once. */
    whenApoReady: function (cb) {
      var self = this;
      var done = false;
      function fire() { if (done) return; done = true; cb(); }

      // Official bus: chain onto any existing onEvent without clobbering it.
      window.mwApoInit = window.mwApoInit || {};
      var prev = typeof window.mwApoInit.onEvent === 'function' ? window.mwApoInit.onEvent : null;
      window.mwApoInit.onEvent = function (event, args) {
        if (prev) { try { prev(event, args); } catch (e) {} }
        if (event === 'init::finish') fire();
      };

      // Bounded poll fallback (and the only signal if the bus never calls).
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        if (document.querySelector('.mw-apo-container') || attempts >= MAX_ATTEMPTS) {
          clearInterval(poll);
          fire();
        }
      }, POLL_INTERVAL);
    },

    onReady: function () {
      this.ready = true;
      ensureRelative(this.host);
      this.bindEvents();
      this.watchApoDom();
      this.render();
    },

    bindEvents: function () {
      var queue = this.queueRender.bind(this);
      // Native colour inputs/selects.
      document.querySelectorAll(
        'input[type="radio"][name="Color"], input[type="radio"][name*="color" i], ' +
        'input[type="radio"][name^="options["], select[name="Color"], select[name*="color" i]'
      ).forEach(function (el) { el.addEventListener('change', queue); });
      // APO option controls (delegated, targeted).
      document.addEventListener('change', function (e) {
        var t = e.target;
        if (!t || !t.matches) return;
        if (t.matches('select[name^="mw_opts"], .mw-option__control, input[type="radio"][name^="mw_opts"]')) {
          queue();
        }
      });
    },

    /** Scoped observer on the APO container only (not body-wide). */
    watchApoDom: function () {
      var apo = document.querySelector('.mw-apo-container');
      if (!apo || typeof MutationObserver === 'undefined') return;
      var self = this;
      var t;
      var observer = new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () { self.queueRender(); }, 50);
      });
      observer.observe(apo, { childList: true, subtree: true, attributes: true });
    },

    queueRender: function () {
      if (this.renderQueued) return;
      this.renderQueued = true;
      var self = this;
      requestAnimationFrame(function () {
        self.renderQueued = false;
        self.render();
      });
    },

    render: function () {
      this.renderBase();
      this.renderOverlays();
    },

    /** Show the base layer matching the selected colour (mode-aware). */
    renderBase: function () {
      var i;
      if (this.mode === 'mybonts') {
        for (i = 0; i < this.baseLayers.length; i++) {
          this.baseLayers[i].style.opacity = '0';
          this.baseLayers[i].style.zIndex = '0';
        }
        return;
      }

      var wanted = this.resolveColour();

      // Graceful degradation: no colour resolved yet → show the first layer.
      if (!wanted) {
        for (i = 0; i < this.baseLayers.length; i++) {
          var first = i === 0;
          this.baseLayers[i].style.opacity = first ? '1' : '0';
          this.baseLayers[i].style.zIndex = first ? '1' : '0';
        }
        return;
      }

      var winner = null;
      for (i = 0; i < this.baseLayers.length; i++) {
        var key = normalizeName(this.baseLayers[i].getAttribute('data-bont-alt') || '');
        if (key && (key === wanted || key.indexOf(wanted + '-') === 0 || key.indexOf(wanted) !== -1)) {
          winner = this.baseLayers[i];
          break;
        }
      }
      if (!winner) winner = this.baseLayers[0] || null;

      for (i = 0; i < this.baseLayers.length; i++) {
        var isWinner = this.baseLayers[i] === winner;
        this.baseLayers[i].style.opacity = isWinner ? '1' : '0';
        this.baseLayers[i].style.zIndex = isWinner ? (this.mode === 'quad' ? '5' : '1') : '0';
      }
    },

    /** Read the currently selected colour value and normalise it. */
    resolveColour: function () {
      var candidates = [];

      // 1. Native Horizon colour radios (exact then fuzzy name match).
      var el = document.querySelector('input[type="radio"][name="Color"]:checked')
            || document.querySelector('input[type="radio"][name*="color" i]:checked');
      if (el) candidates.push({ kind: 'named-colour', value: el.value });

      // 2. Native colour <select>.
      var sel = document.querySelector('select[name="Color"], select[name*="color" i]');
      if (sel && sel.value) {
        var opt = sel.options[sel.selectedIndex];
        candidates.push({ kind: 'select', value: sel.value, text: (opt && opt.textContent) || '' });
      }

      // 3. APO variant shim. Single-value colours (or colours exposed only via
      //    APO) never render a native name="Color" input — they reach the DOM
      //    solely through the shim, whose radios are named `apo-option-N` but
      //    whose wrap carries the real option name in `data-option-name`. Reading
      //    it here fixes products (e.g. the roller-derby skate) whose base image
      //    otherwise fell back to the first (hero) gallery layer.
      var wraps = document.querySelectorAll('.variant-input-wrap[data-option-name]');
      for (var w = 0; w < wraps.length; w++) {
        var checked = wraps[w].querySelector('input[type="radio"]:checked');
        if (checked) {
          candidates.push({
            kind: 'shim',
            optionName: wraps[w].getAttribute('data-option-name') || '',
            value: checked.value
          });
        }
      }

      // 4. Generic native options[...] radios that look like a colour.
      var radios = document.querySelectorAll('input[type="radio"][name^="options["]:checked');
      for (var i = 0; i < radios.length; i++) {
        candidates.push({
          kind: 'generic-option',
          name: radios[i].getAttribute('name') || '',
          value: radios[i].value || ''
        });
      }

      return resolveColourFromCandidates(candidates);
    },

    /** Build/update overlay <img> nodes for selected APO options (diffing). */
    renderOverlays: function () {
      if (!this.host) return;

      var desired = [];
      var seen = {};
      document.querySelectorAll(
        'select[name^="mw_opts"] option:checked, .mw-option__control option:checked, input[type="radio"][name^="mw_opts"]:checked'
      ).forEach(function (el) {
        var v = el.value;
        if (v && v.indexOf('v_') === 0 && !seen[v]) { seen[v] = true; desired.push(v); }
      });

      var existing = {};
      this.host.querySelectorAll('.overlay-image').forEach(function (img) {
        var id = img.getAttribute('data-value-id');
        if (id) existing[id] = img;
      });

      var self = this;
      desired.forEach(function (valueId, index) {
        // Skip non-visual groups (e.g. "Bearing") — match the OPTION's own group
        // label. Scope to the `.mw-option` block (which holds the label); the old
        // closest('.mw-stack--vertical') landed on the control wrapper, so it read
        // the first <option> text ("-- Please Select --") and never matched.
        var valueEl = document.querySelector(
          'option[value="' + valueId + '"], input[type="radio"][name^="mw_opts"][value="' + valueId + '"]'
        );
        var optionBlock = valueEl ? valueEl.closest('.mw-option') : null;
        if (optionBlock) {
          var labelEl = optionBlock.querySelector('.mw-text--style-strong');
          var labelText = labelEl ? labelEl.textContent.toLowerCase().replace(/\s+/g, '') : '';
          if (labelText.indexOf('bearing') !== -1) {
            return;
          }
        }

        var z = getOverlayZIndex(self.mode, index);

        if (existing[valueId]) {
          existing[valueId].style.zIndex = String(z);
          delete existing[valueId];
          return;
        }

        var media = document.querySelector('.mw-option__media[data-value-id="' + valueId + '"]:not(.mw-hidden)');
        if (!media || !media.closest('.mw-stack__item:not(.mw-hidden)')) return;

        var img = media.querySelector('img');
        var source = media.querySelector('source');
        var src = (img && (img.getAttribute('src') || img.getAttribute('data-src')))
               || (source && firstFromSrcset(source.getAttribute('srcset')))
               || '';
        if (!src) return;
        src = stripShopifyParams(src);

        var overlay = document.createElement('img');
        overlay.className = 'overlay-image';
        overlay.setAttribute('data-value-id', valueId);
        overlay.alt = '';
        overlay.decoding = 'async';
        overlay.style.zIndex = String(z);
        overlay.style.opacity = '0';
        overlay.style.pointerEvents = 'none';
        overlay.onload = function () { overlay.style.opacity = '1'; };
        overlay.src = src;
        ensureRelative(self.host);
        self.host.appendChild(overlay);
      });

      // Remove overlays no longer selected.
      Object.keys(existing).forEach(function (id) {
        var img = existing[id];
        img.style.opacity = '0';
        var removed = false;
        function cleanup() { if (removed) return; removed = true; if (img.parentNode) img.parentNode.removeChild(img); }
        img.addEventListener('transitionend', cleanup, { once: true });
        setTimeout(cleanup, 300);
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { window.apoImageSwap.init(); });
  } else {
    window.apoImageSwap.init();
  }

  } // end DOM engine guard

  // CommonJS export shim (for node --test; harmless in browser).
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { normalizeName: normalizeName, stripShopifyParams: stripShopifyParams, firstFromSrcset: firstFromSrcset, getOverlayZIndex: getOverlayZIndex, isColourOptionName: isColourOptionName, resolveColourFromCandidates: resolveColourFromCandidates };
  }
})();
